"use client";

import { Icon } from "@repo/dashboard-core";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";

import { WHATSAPP_LINK } from "@/config/contact";

const DISMISS_STORAGE_KEY = "tu:whatsapp-cta:dismissed";

export function WhatsAppFloatingCTA({
  raised = false,
}: {
  /** Stack above Crisp's default bottom-right bubble (GD-79) when Crisp is
   * also mounted, so the two floating buttons don't overlap. */
  raised?: boolean;
}) {
  const t = useTranslations("whatsapp");
  const [mounted, setMounted] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    setDismissed(sessionStorage.getItem(DISMISS_STORAGE_KEY) === "1");
    setMounted(true);
  }, []);

  if (!mounted || dismissed) return null;

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISS_STORAGE_KEY, "1");
    setDismissed(true);
  };

  return (
    <>
      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t("aria-label")}
        title={t("tooltip")}
        className={`fixed right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition hover:scale-105 hover:bg-[#20bd5a] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#25D366] focus-visible:ring-offset-2 ${raised ? "bottom-24" : "bottom-6"}`}
      >
        <Icon name="whatsapp" size={30} color="white" />
      </a>
      <button
        type="button"
        onClick={handleDismiss}
        aria-label={t("dismiss-aria-label")}
        className={`fixed right-4 z-50 flex h-6 w-6 items-center justify-center rounded-full bg-white text-text-secondary shadow-md transition hover:text-text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1 ${raised ? "bottom-[134px]" : "bottom-[60px]"}`}
      >
        <Icon name="close" size={14} />
      </button>
    </>
  );
}
